import { TableCell, TableRow } from "@mui/material";
import { strDateFormatWithTime, mapStatus, mapSubtatus, mapPickingStatus } from "../utils/functions";
const ForRoutingAdminOrderPickupsRow = ({ pickup, columns, color }) => {
  const getNestedValue = (obj, path) => {
    return path
      .split(".")
      .reduce((acc, key) => (acc ? acc[key] : undefined), obj);
  };
  return (
    <>
      <TableRow
        sx={{ "& > *": { borderBottom: "unset" } }}
        style={{ backgroundColor: color }}
      >
        {columns.map((col) => {
          const value = getNestedValue(pickup, col.dbName);
          let displayValue = value;
          if (["order.created_at", "created_at"].includes(col.dbName)) {
            displayValue = strDateFormatWithTime(new Date(value))
          }

          if (col.dbName === "state") {
            displayValue = mapPickingStatus(value);
          }

          if (col.dbName === "delivery.status") {
            displayValue = mapStatus(value);
          }

          if (col.dbName === "delivery.substatus") {
            displayValue = mapSubtatus(value);
          }
          return (
            <TableCell key={col.dbName}>
              {displayValue}
            </TableCell>
          );
        })}
      </TableRow>
    </>
  );
};

export default ForRoutingAdminOrderPickupsRow;
